export const _LOAD_MODEL_ = 'Load:ServiceModel';
export const _RELOAD_TYPE_ = 'Reload:ServiceType';
export const _LOAD_EQUIPMENT_SERVICE_ = 'Load:Equipment';
export const _RELOAD_EQUIPMENT_SERVICE_ = 'Reload:Equipment';
export const _DELETE_PRODUCT_EQUIPMENT_SERVICE_ = 'Delete:EquipmentServices';

export const _DELETE_SERVICE_ = 'Delete:Service';

export const _SAVE_SERVICE_SUCCESS_ = 'Save:ServiceSuccess';

export const SAVE_EQUIPMENT_REQUEST_SERVICE = 'Save:EquipmentPageServices';
export const SEARCH_EQUIPMENTS_SERVICE = 'Search:EquipmentsPageService';

export const _FINISHED_SAVE_REQUEST_ = 'SaveRequest:Finished';

export const MODEL = {
  id: null,
  name: null,
  slug: null,
  price: null,
};
